var _defs, _ellipse, _path, _path2, _path3, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _rect, _rect2, _polygon, _path4, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect3, _rect4, _rect5, _rect6, _rect7, _path13, _rect8, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon3, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle2, _circle3, _path60, _path61, _path62, _path63, _path64, _polygon4, _polygon5, _path65, _polygon6, _path66, _polygon7, _path67;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "9384b02b-49b7-431a-934f-218f90990cfd",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 941.51,
    height: 824.82,
    viewBox: "0 0 941.51 824.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0d57a94-2a20-4bb1-ba9f-a5b1ad7b8bc7",
    x1: 432.56,
    y1: 817.82,
    x2: 432.56,
    y2: 166.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "businesswoman") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.08,
    cy: 798.12,
    rx: 42.38,
    ry: 356.13,
    transform: "translate(-503.7 1128.97) rotate(-82.14)",
    fill: "#e87100",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.6,606.48c6.41,15.45,14.82,30.26,26.59,41.62,14.34,13.84,32.15,21.39,51.22,25a154.27,154.27,0,0,0,17,2.2c15.07,1.16,30.5.39,45.3-1.22a535.59,535.59,0,0,0,106.7-22.83q8.55-2.76,17-5.81,12.75-4.57,25.27-9.81c34-14.21,69.15-32.33,105.32-26.71,17.53,2.73,34,11,51.57,13.46a92.21,92.21,0,0,0,36.84-2.62,126.59,126.59,0,0,0,17-5.87,193.44,193.44,0,0,0,35.32-20c26.5-18.52,50.28-41.48,78.18-57.52,30.76-17.69,64.81-26.1,99.5-32.37q8.48-1.53,17-2.92c16.05-2.65,32.14-5.1,48-8,15.28-2.82,30.83-6.27,44.13-14.75,9.49-6,17.47-14.43,24.79-23.26a277.49,277.49,0,0,0,34.52-53.22q.75-1.5,1.47-3c14.69-30.14,24.57-63,30.63-97,.18-1,.35-2,.52-3,5.7-33.33,7.78-67.79,7.15-102l-.06-3c-.39-16.89-1.44-33.71-3-50.29-1.12-11.66-2.62-23.76-8.66-33.56s-15.87-16.1-25.71-21.34c-43.3-23.07-84.81-29.49-131.39-18.31-7.48,1.79-14.93,3.72-22.38,5.72-5.67,1.52-11.34,3.09-17,4.67-39.13,10.91-78.16,22.52-118.61,26q-5.87.51-11.73.78-11.61.54-23.22.24a401.19,401.19,0,0,1-59.44-6.12q-8.52-1.47-17-3.26C608,93.29,583.83,86.5,560,79q-7.29-2.3-14.56-4.68c-10.92-3.57-21.84-7.21-32.78-10.75C480,53,447.18,43.31,413.41,39.41q-4.34-.49-8.68-.87c-2.77-.24-5.55-.43-8.32-.57-52.45-2.8-105.5,9.85-152,35.74q-8.66,4.82-17,10.24-11.57,7.53-22.43,16.2c-14.84,11.85-28.73,25.34-39.31,41.55-10.31,15.79-17,33.52-20.85,52.16-.21,1-.41,2-.59,3-5.65,30.09-3.89,62.36,2.45,92.51.67,3.16,1.38,6.33,2.12,9.49.23,1,.47,2,.71,3,6.84,28.51,15.58,56.94,13.3,86.09-.29,3.67-.75,7.31-1.35,10.91-.17,1-.34,2-.53,3-4.46,23.78-14.6,46.34-20.68,69.89A215.32,215.32,0,0,0,149.6,606.48Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.41,298.86H148.8c.23,1,.47,2,.71,3h77.9v97H161.46c-.17,1-.34,2-.53,3h66.48V673.09a154.27,154.27,0,0,0,17,2.2V401.86h152V651.24q8.55-2.76,17-5.81V401.86h219V619.75a126.59,126.59,0,0,0,17-5.87v-212h213V504q8.48-1.53,17-2.92V401.86h151.46q.75-1.5,1.47-3H879.41v-97H1063c.18-1,.35-2,.52-3H879.41v-102h191.23l-.06-3H879.41V76.08c-5.67,1.52-11.34,3.09-17,4.67V193.86h-208l-.52-.57,78.16-85.77q-11.61.54-23.22.24L649.41,173V101.64q-8.52-1.47-17-3.26V169.7L545.48,74.31c-10.92-3.57-21.84-7.21-32.78-10.75L630.91,193.29l-.52.57h-217V39.41q-4.34-.49-8.68-.87c-2.77-.24-5.55-.43-8.32-.57V193.86h-152V73.71q-8.66,4.82-17,10.24V193.86H144.82c-.21,1-.41,2-.59,3h83.18Zm169-102v102h-152v-102Zm17,0h219v102h-219Zm449,102h-213V199.59l3-2.73h210Zm-213,100v-97h213v97Zm-236,0v-97h219v97Zm-169-97h152v97h-152Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M667.19,225a12.9,12.9,0,0,1,4.38-2.49,29.44,29.44,0,0,1,11.14-1.21,49,49,0,0,1,8.17,1.14L816.52,258c2.37.67,4.7,1.46,7,2.34,8.1-3.17,31-12.35,33.51-15.63l9.84,2.88-16.42,24.51h0a2.25,2.25,0,0,1-.16,4.18c-18.93,6.51-47.52-2.12-47.52-2.12L693,242.8S659.83,231.6,667.19,225Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 812.37,
    cy: 264.25,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(178.1 915.67) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 808.56,
    cy: 263,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(176.68 911.19) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.25,
    cy: 260.59,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(173.94 902.59) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 780.64,
    cy: 254.54,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(165.52 878.85) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.01,
    cy: 253.34,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(164.16 874.59) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.25,
    cy: 252.46,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(162.42 870.41) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 769.47,
    cy: 251.22,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(161 865.97) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 765.77,
    cy: 250,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(159.61 861.61) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.4,
    cy: 248.89,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(158.35 857.65) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.8,
    cy: 247.7,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(157 853.41) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 755.02,
    cy: 246.46,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(155.59 848.97) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 751.68,
    cy: 245.36,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(154.33 845.04) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 732.91,
    cy: 240.51,
    rx: 1.6,
    ry: 0.96,
    transform: "matrix(0.31, -0.95, 0.95, 0.31, 146.04, 823.88)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 725.61,
    cy: 238.11,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(143.31 815.29) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 721.93,
    cy: 236.9,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(141.93 810.96) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 718.37,
    cy: 235.72,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(140.6 806.78) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 714.86,
    cy: 234.57,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(139.28 802.65) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.9,
    cy: 233.26,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(137.8 797.98) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.14,
    cy: 239.27,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(144.63 819.44) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 804.62,
    cy: 261.7,
    rx: 1.6,
    ry: 0.96,
    transform: "translate(175.2 906.55) rotate(-71.78)",
    fill: "#e87100",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 744.05,
    y: 242.28,
    width: 3.54,
    height: 6.17,
    transform: "translate(1281.86 624.71) rotate(-166.13)",
    fill: "#e87100",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 703.55,
    y: 230.67,
    width: 3.54,
    height: 6.17,
    transform: "translate(1204.83 592.14) rotate(-166.13)",
    fill: "#e87100",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "557.55 185.21 562.12 186.41 559.84 189.85 553.07 188.17 557.55 185.21",
    fill: "#e87100",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M671.57,222.55l9.87,2.57,3.76-2.32-2.49-1.46A29.44,29.44,0,0,0,671.57,222.55Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M866.87,247.53l-16.42,24.59-26.82-11.89S854,248.65,857,244.65Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "618.51 213.63 661.84 225.33 664.4 230.45 618.51 213.63",
    fill: "#e87100",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.5,126.62h1.31a3.24,3.24,0,0,1-1.6-2.62h0c0-2.06,2.53-3.75,5.62-3.75h39.42c3.09,0,5.62,1.69,5.62,3.75h0c0,2.07-2.53,3.76-5.62,3.76h-1.32a3.27,3.27,0,0,1,1.61,2.62c0,1.76-1.84,3.25-4.31,3.65h11.35c3.09,0,5.63,1.69,5.63,3.75s-2.54,3.76-5.63,3.76H330.16c-3.09,0-5.62-1.69-5.62-3.76,0-1.76,1.84-3.24,4.3-3.64H317.5c-3.1,0-5.63-1.69-5.63-3.76S314.4,126.62,317.5,126.62Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M744.66,162.39H746a3.26,3.26,0,0,1-1.6-2.62h0c0-2.07,2.53-3.76,5.62-3.76h39.42c3.09,0,5.62,1.69,5.62,3.76h0c0,2.06-2.53,3.75-5.62,3.75h-1.32a3.28,3.28,0,0,1,1.61,2.62c0,1.77-1.84,3.25-4.3,3.65h11.34c3.1,0,5.63,1.69,5.63,3.76s-2.53,3.75-5.63,3.75H757.33c-3.1,0-5.63-1.69-5.63-3.75,0-1.76,1.84-3.25,4.3-3.65H744.66c-3.1,0-5.63-1.69-5.63-3.76S741.56,162.39,744.66,162.39Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257,315.45h1.32a3.26,3.26,0,0,1-1.61-2.62h0c0-2.07,2.53-3.76,5.62-3.76h39.42c3.09,0,5.62,1.69,5.62,3.76h0c0,2.06-2.53,3.75-5.62,3.75h-1.32a3.26,3.26,0,0,1,1.61,2.62c0,1.76-1.84,3.25-4.3,3.65h11.34c3.1,0,5.63,1.69,5.63,3.76s-2.53,3.75-5.63,3.75H269.71c-3.1,0-5.63-1.69-5.63-3.75,0-1.77,1.84-3.25,4.31-3.65H257c-3.09,0-5.63-1.69-5.63-3.76S254,315.45,257,315.45Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M686.15,334c-1-6.29-7.28-17.79-7.28-17.79l-9.07-15.4s-3.56-4.21-3.23-5.57-4.21-3.61-4.21-3.61-2.59-3.38-2.75-5-14.73-13.86-14.73-13.86-5-4.19-3.88-18.36H629.51a61,61,0,0,0-8.75.87L604,235.71s-13.19-10.93-24.85-17.38c0-.1,0-.2,0-.3a35.27,35.27,0,0,0-6.41-20.4l-.12-.16a15.6,15.6,0,0,0,5.2-2.4,6.4,6.4,0,0,0,2.32-2.85c1.87-4.8-5.51-7-8.88-8.73-6.83-3.52-12.51-8.76-19.48-12a52,52,0,0,0-44.33.28c-6.81,3.37-12.74,8.21-18.86,12.7-9.59,7-5.9,13.45-13.4,22.67s-11.74,22.21-7.05,33.11c2.76,6.4,8.25,11.31,14.28,14.85s-1.33,5.88,5.13,8.56c1.52.64,3.18,1.43,3.8,3a6.07,6.07,0,0,1-.17,3.94c-1.19,4.25-2.77,8.83-1.93,13-4,1.87-6.75,2.91-6.75,2.91-8.3,2.9-9.71,8.77-9.71,8.77s1.51,5.2-1.83,7.78-1.94,9.66-1.94,9.66-4.53,10.2-3.36,11.7a28.47,28.47,0,0,1,2.39,4.09s-3.78,3-1.84,7.3,0,8.91,0,8.91,1,2.37-.75,3.66,0,11.11,0,11.11a5.83,5.83,0,0,1-1.41,3.6c-1.46,1.72,0,18.47,0,18.47a5.62,5.62,0,0,1-1.78,2.1c-1,.48-3.88,16.27-3.07,17.07S447,439.5,447,439.5s.32,6.6-1.46,7.73-2.1,8.7-2.1,8.7.8,6.76-2.43,8.05-3.89,24.17-3.89,24.17-4.37,11.76-7,13.69a33.19,33.19,0,0,0,9.51,8l-.4,1.06c-2.19,6-5.17,15.3-5.56,23a50.72,50.72,0,0,0-7.06,8.46s1.16,1,2.57,2.2L396.1,585.4c-13.52-19.37-20.86-12.19-20.86-12.19l-5,1.37c-.77.18-3.76.67-4-2.68a9.38,9.38,0,0,0-.72-2.88,7.28,7.28,0,0,0-2.1-2.88,4.51,4.51,0,0,0-4.63-.67c-4.2,1.62-59.46,11-59.46,11s-17.25,2.9-33.11,23.84a268.6,268.6,0,0,1-30.1,33.83L193,685.33s-21.76,29.41-11.2,28.88c-2.57,6.31-.13,12.68-.13,12.68l42.72,54.38a8.74,8.74,0,1,0,14.36-6.66l63.77-29.56a8.72,8.72,0,1,0,13.34-11L340,709.82s71.53-75.07,77-86.35c3.11-6.38-2.36-15.14-7.69-21.53l45.64-59,1.64.74,9.18-9.37c7-5.62,1.07-12.86,1.07-12.86-2.09-1.89-6.07-1.6-10.57-.32.42-1.8.8-3.55,1.12-5.19.09-.44.18-.87.26-1.3a42.06,42.06,0,0,0,8.56-.87s1-21.1,3.88-29.48l8.58-42.69s5.18-18.2,7.12-28.19,10.47-48.33,10.47-48.33c1.39-4.19,2,7.09,2,7.09s2.81,2.9,2.16,4.4.54,10.1.54,10.1,1.51,5.15.44,6.23a2.69,2.69,0,0,0-.49.88c-1,2.3-2.33,9.37-2.33,9.37l-3.79,14.05-.63.51a19.6,19.6,0,0,0-5.45,7.82c-1.15,2.68-1.81,5.22-2.49,6.84a4.82,4.82,0,0,1-.58,1,7.85,7.85,0,0,0-1,1.77,35.61,35.61,0,0,0-1.94,6.87l.45.29c0,.09-.07.19-.11.28l-.19.48,0,.06c-.41,1-.79,2.05-1.17,3.09l-.12.33c-.35,1-.69,2-1,2.95-.05.17-.11.34-.16.51-.31.93-.6,1.86-.88,2.77l-.18.58c-.26.87-.52,1.73-.76,2.57,0,.1-.06.21-.09.3a84.59,84.59,0,0,0-3.24,22.13c-.23,17.66-.4,53.31,1.78,58.13.14.32.29.69.43,1.1,2.7,7.91,4.75,31.76,4.75,31.76a38.72,38.72,0,0,0,4.51,2.67c.05.45.1.9.16,1.37,1.15,9.81,2.77,23.08,3.31,24.42.87,2.15,2.81,15,2.81,15s-1.52,5.79-2.59,11.16-15.11,20.2-15.11,20.2C457.41,659,439.5,711.43,439.5,711.43c-3.57,7.68-7.51,10.52-10.41,11.5-19.33-.72-20.23,15-20.23,15l-12.2,23.41,3.09,2.19,1.45,1,12.41-14.39s0,16.43-2.27,20.4c-1.54,2.7-1.79,7.65-1.79,10.55,0,1.36.06,2.27.06,2.27s3.78,8,20.39,17.9c7.46,4.43,11.81,3.68,14.34,1.49,3.1-2.68,3.47-7.5,3.47-7.5l-7-11.89c-.35.15-.69.26-1,.39,0-.41,0-.83,0-1.28.44-10.5,9.88-32.65,9.88-32.65s9.06-23.85,16.61-31.15c6.59-6.37,33.05-46.59,39.69-56.74l0,.34c0,.49.07,1,.12,1.42,1,10.87,4,15.67,4,15.67s3.45,44,4.09,55.2c.41,7-1.3,11.73-2.64,14.28l-.07.12c-.07,0-6.89,3.58-7.53,10.52s3.23,13.53,3.23,13.53S516,795,515.68,801.32h5.18L520,782.2l.08.1c.94,1.25,10.19,13.66,10.5,19.87,0,0,2.34,6.39,2.27,8.14a.66.66,0,0,1,0,.14c-.22,1.5,8.2,8.59,20.4,7.19s14.34-3.11,14.34-3.11.14-.39.32-1c.61-2.3,1.58-7.91-2.47-10.68-5.07-3.47-15.61-13.2-16.06-13.61l0,0c-1.73-14.39-7.24-33.94-7.24-33.94V725.82s2.49-67.45.77-78.83a60.06,60.06,0,0,1,0-19.55s7.55-21.26,6-23.63,3.23-10.74,3.23-10.74l9.07-25.43.53-1.48h0c1.48-.56,2.45-.93,2.8-1,3-.64,0-5.48,0-5.48s9.62-40.91,8.64-48.33,2.27-37.85,2.27-37.85L577,460.88l.14-1.13c1,1.24,1.7,2,1.7,2,10.35-1.72,19.2-30,16.93-31.58s-8.63-22.23-8.63-22.23c-10.14-14.07-1-43.28-1-43.28s9.28-23.52,9.17-27.39,2.16-4,2.16-4l0-.11c8.52,1.82,38.11,8.11,39.63,8.42,1.78.36,5.34.6,8.9,2.05s26.55-2.05,26.55-2.05S687.12,340.26,686.15,334Zm-229,197.1-7.46,9.48,1.11.5-45.37,56.56c-2.42-2.53-4.23-4.12-4.23-4.12-.46-.81-.92-1.58-1.37-2.34l33.7-43a3.51,3.51,0,0,0,.62.4l2.67-3.18a7.39,7.39,0,0,0,2.52,1.46c6.33,2.17,11-6.08,14.2-15.81A8.72,8.72,0,0,1,457.15,531.08ZM558.62,258.21c0-.11,0-.22,0-.33,0,.09,0,.2,0,.33Zm0-.58a2.3,2.3,0,0,1,0,.23A1.77,1.77,0,0,0,558.64,257.63Zm62.13,44.13s-1.46-4.51-2.43-4.51a14.06,14.06,0,0,1-3.56-1.29,2.86,2.86,0,0,1-3.56-2.21c-1-3-7.18-5.36-7.18-5.36s-9.06-3.76-9.82-6.88-13.7-6.55-13.7-6.55.87-1.28-4.64-3.11a20.44,20.44,0,0,1-5.32-3.25,122.9,122.9,0,0,1-11.91-11,32.3,32.3,0,0,1,1.17-6.91c.14-.51.29-1,.46-1.5a32.31,32.31,0,0,0,7.1-4.76l6.72,9.75a2.25,2.25,0,0,0,3.12.58l5.36-3.65a20.21,20.21,0,0,0,9,1.33l11.93,14.39a11.69,11.69,0,0,0,.51,4.84l27.73,32.87C631,304.34,620.77,301.76,620.77,301.76Z",
    transform: "translate(-129.25 -37.59)",
    fill: "url(#b0d57a94-2a20-4bb1-ba9f-a5b1ad7b8bc7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M626.22,254.65s-30.53.32-25.33,17.23l11.65,6.76,11.61-2.36,5.45-9.63Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M626.22,254.65s-30.53.32-25.33,17.23l11.65,6.76,11.61-2.36,5.45-9.63Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M559.72,225.18c8.37,30.44,28.78,27.47,28.78,27.47l13.09,15.85,1.93,2.46,4.18,5.32,18.52-10.52-3.69-4.34L600.89,236S551.35,194.75,559.72,225.18Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#fbbebe"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 556.64,
    y: 231.36,
    width: 0.56,
    height: 4.65,
    rx: 0.28,
    ry: 0.28,
    transform: "translate(1019.14 73.86) rotate(145.56)",
    fill: "#3a3768"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 569.39,
    y: 217.96,
    width: 0.32,
    height: 1.53,
    rx: 0.16,
    ry: 0.16,
    transform: "translate(1033.71 39.44) rotate(145.56)",
    fill: "#3a3768"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 571.26,
    y: 220.17,
    width: 0.36,
    height: 2.66,
    rx: 0.18,
    ry: 0.18,
    transform: "matrix(-0.82, 0.57, -0.57, -0.82, 1038.75, 43.43)",
    fill: "#3a3768"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 573.32,
    y: 223.14,
    width: 0.34,
    height: 2.69,
    rx: 0.17,
    ry: 0.17,
    transform: "translate(1044.16 47.7) rotate(145.56)",
    fill: "#3a3768"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 559.86,
    y: 215.91,
    width: 18.87,
    height: 38.36,
    rx: 2.24,
    ry: 2.24,
    transform: "translate(1042.51 69.42) rotate(145.56)",
    fill: "#3a3768"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M554.65,223.08a.68.68,0,0,1,.94.18l.08.11a.68.68,0,0,0,.94.18l6.61-4.53a.68.68,0,0,0,.17-.94l-.08-.11a.68.68,0,0,1,.18-.94l1.28-.89a1.3,1.3,0,0,1,1.8.34l19.1,27.86a1.29,1.29,0,0,1-.34,1.79L573.82,254a1.29,1.29,0,0,1-1.79-.34l-19.11-27.86a1.29,1.29,0,0,1,.34-1.79Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 558.35,
    y: 219.88,
    width: 2.64,
    height: 0.54,
    rx: 0.27,
    ry: 0.27,
    transform: "translate(1016.49 47.61) rotate(145.56)",
    fill: "#e6e8ec"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 428.75,
    cy: 183.7,
    r: 0.3,
    fill: "#e6e8ec"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M503.3,662.06c0,.6.09,1.18.14,1.76,1,10.86,3.95,15.66,3.95,15.66s3.43,44,4.07,55.18c.41,7-1.3,11.72-2.63,14.27a12.7,12.7,0,0,1-1.44,2.27l-2.15,4.72,10.09,20.18,11.81,19.54,8.16,10.73s6,.86,7.3,0,6.43,0,6.43,0l4.73-7.3-5.3-7.17-2-2.7c-1.72-14.39-7.2-33.93-7.2-33.93V725.86s2.48-67.41.76-78.8a60.28,60.28,0,0,1,0-19.53s7.51-21.26,6-23.62,3.22-10.74,3.22-10.74l9-25.41.52-1.49-2-4.87L506.1,555s.4,4,.84,10.35v.14c.26,3.68.52,8.16.73,13.16.7,16.82.76,39.4-2.43,56.65A108.44,108.44,0,0,0,503.3,662.06Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#fbbebe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M503.44,663.82l2.66-4.09a89.9,89.9,0,0,1,16.31-12.45c9.24-5.37,11.38-18,11-19.75s1.29-18,1.29-18V568.27l-27.71-3c1.1,16.07,2.45,47.51-1.7,70C503,647.47,502.81,656.88,503.44,663.82Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M417,766.87l2.15,19.75,10.51,6.22s9.67,1.08,7.95-7.51a12.59,12.59,0,0,1-.16-2.79c.43-10.49,9.82-32.63,9.82-32.63s9-23.83,16.53-31.14c6.56-6.36,32.89-46.56,39.5-56.71l1.51-2.33a90.19,90.19,0,0,1,16.32-12.45c9.23-5.37,11.38-18,11-19.75s1.28-18,1.28-18V568.27l-26.42-2.82-23.82-2.55s.53,4.66,1.21,10.59c1.15,9.8,2.77,23.07,3.3,24.41.87,2.15,2.8,15,2.8,15s-1.51,5.79-2.58,11.16-15,20.19-15,20.19c-17.82,14.81-35.64,67.19-35.64,67.19-4.69,10.14-10,11.86-12.76,12a5.45,5.45,0,0,1-1.84-.17l-3.87,7.09Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#fbbebe"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M505.24,755.92l10.09,20.18,11.81,19.54,8.16,10.73s6,.86,7.3,0,6.43,0,6.43,0l4.73-7.3-5.3-7.17c1.39,3.2,2.53,7.19-.28,7.38-4.72.33-14.49,4.3-20.07-9.12s-13-19.43-13-19.43l-5.91-14.38-.38-7.42a12.7,12.7,0,0,1-1.44,2.27Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M504.49,773.09s8.8,21.9,8.48,28.24h5.15l-.86-19.12.08.11c.94,1.25,10.14,13.65,10.45,19.86,0,0,2.33,6.38,2.26,8.13a.61.61,0,0,1,0,.14c-.22,1.5,8.15,8.59,20.29,7.19s14.27-3.11,14.27-3.11.14-.39.32-1c.6-2.3,1.57-7.9-2.46-10.67-5.05-3.48-15.58-13.24-16-13.61.27.48,6.32,11,1.7,11.35s-14.49,4.3-20.07-9.12-13-19.43-13-19.43l-5.91-14.38-.44-8.59s-6.86,3.54-7.5,10.52S504.49,773.09,504.49,773.09Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M511.9,781.89c.61,5.14,2.12,14.6,2.9,19.44h3.32l-.86-19.12.08.11-.29-.85S511,774.81,511.9,781.89Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M530,810.45c-.22,1.5,8.15,8.59,20.29,7.19s14.27-3.11,14.27-3.11.14-.39.32-1c-7.56.09-27.74,0-34.87-3.19A.61.61,0,0,1,530,810.45Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M417,766.87l2.15,19.75,10.51,6.22s9.67,1.08,7.95-7.51a12.59,12.59,0,0,1-.16-2.79c-16.23,6-17.87-9.88-17.87-9.88l2.9-43.26a9.46,9.46,0,0,1,1.94-5.95,5.45,5.45,0,0,1-1.84-.17l-3.87,7.09Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M394.56,761.39l3.07,2.2,1.44,1,12.35-14.38s0,16.42-2.26,20.39c-1.53,2.7-1.77,7.65-1.77,10.55,0,1.36.05,2.27.05,2.27s3.76,8,20.29,17.89c7.42,4.43,11.75,3.67,14.26,1.49,3.09-2.68,3.45-7.5,3.45-7.5l-7-11.88c-17.18,7-18.89-9.49-18.89-9.49l2.9-43.26c.21-6.55,4.36-7.71,4.36-7.71-19.25-.74-20.14,15-20.14,15Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.39 726 269.82 727.02 282.17 712.64 280.77 708.45 268.39 726",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M407.39,781.17c0,1.36.05,2.27.05,2.27s3.76,8,20.29,17.89c7.42,4.43,11.75,3.67,14.26,1.49C434.46,800.49,416.5,793.87,407.39,781.17Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M437,546.91c9.55,3.29,15.28-17.37,18-30.85,1.26-6.29,1.85-11,1.85-11H439.27s-1,2.37-2.37,6C433,521.72,426.55,543.3,437,546.91Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#fbbebe"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M514.68,268.13l12,29.19v25.12c0,.65,29.84,9,29.84,9l7.73-19.32s2.36-22.76-6.22-41.66a28.11,28.11,0,0,1-1.17-19.57q.21-.76.45-1.5a49.28,49.28,0,0,1,9.52-16.5s-20.47-6.79-34.53-8.17c-8.85-.86-15.18.42-12.27,6.88a28.63,28.63,0,0,1,2.32,13c0,.4,0,.81-.08,1.21C521.39,257.85,514.68,268.13,514.68,268.13Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#fbbebe"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M520.06,231.62a28.63,28.63,0,0,1,2.32,13c0,.4,0,.81-.08,1.21a.27.27,0,0,0,.08.07,31.7,31.7,0,0,0,18.21,7.91c.93.09,1.88.13,2.83.13a31.25,31.25,0,0,0,13.47-3q.21-.76.45-1.5a49.28,49.28,0,0,1,9.52-16.5s-20.47-6.79-34.53-8.17C523.48,223.88,517.15,225.16,520.06,231.62Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M510.67,218.3a35,35,0,0,0,11.71,26.32,31.75,31.75,0,0,0,18.21,7.9c.93.09,1.88.13,2.83.13a31.38,31.38,0,0,0,13.92-3.24,34.51,34.51,0,0,0,18.84-31.11,35.3,35.3,0,0,0-6.39-20.39,32.24,32.24,0,0,0-26.37-14C525.34,183.94,510.67,199.32,510.67,218.3Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#fbbebe"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M555.48,329.31s-20-18.25-25.55-34.78a183.18,183.18,0,0,0-13.31-29.84l1.48-3.09s8.18,21.77,14.19,24.34,20,17.39,21.26,27.7l.86-31.35,1.35-20.69s10.24,21.77,11.1,31.86-.22,28.34-3.44,32.2A10.49,10.49,0,0,1,555.48,329.31Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M513.62,261l.14-.13-.14.13Z",
    transform: "translate(-129.25 -37.59)",
    fill: "none",
    stroke: "aqua",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M483.12,562.9s.53,4.66,1.21,10.59c7.08,3.56,15.15,5,23.34,5.12a108.3,108.3,0,0,0,25.69-3.06,189.11,189.11,0,0,0,24.92-7.79l.52-1.49-2-4.87L506.1,555s.4,4,.84,10.35v.14Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M474.54,536.6c.14.32.29.7.43,1.11,2.69,7.9,4.72,31.74,4.72,31.74,28.34,19.65,78.9-3.54,81.89-4.19s0-5.47,0-5.47,9.57-40.9,8.61-48.31,2.25-37.84,2.25-37.84L574,461l4.29-35.87-32.85-7.08s-40.19,4.08-53,8.85a17.76,17.76,0,0,0-1.75.74c-3.93,1.94-7.44,8.35-10.27,15.55-1.73,4.37-3.2,9-4.38,13.16a84.85,84.85,0,0,0-3.22,22.12C472.54,496.16,472.37,531.78,474.54,536.6Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M474.54,536.6c.14.32.29.7.43,1.11,1.84-12.74,3.58-51.13,3.22-63.69-.43-15,15.46-46.81,15.46-46.81l-1.26-.27a17.76,17.76,0,0,0-1.75.74c-6.32,3.12-11.54,17.81-14.64,28.71a84.86,84.86,0,0,0-3.23,22.12C472.54,496.16,472.37,531.79,474.54,536.6Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M480.37,443.23c.82.54,17.44,11.24,45.37,23.17,28.67,12.23,31.78-37.47,31.78-37.47A51.37,51.37,0,0,1,563,442.78c1.59,6.35,7.83,14.47,11,18.26l4.29-35.87-32.85-7.08s-40.19,4.08-53,8.85a17.76,17.76,0,0,0-1.75.74C486.71,429.62,483.2,436,480.37,443.23Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M463.8,336c1.93,4.29,0,8.91,0,8.91s28.45,24.58,29.85,20.39,2,7.09,2,7.09,2.8,2.9,2.16,4.4.53,10.09.53,10.09,1.5,5.15.43,6.23-2.68,10-2.68,10l-3.84,14.26-.67.56c-6,4.93-6.77,13.52-8.49,15.67s-2.78,8.37-2.78,8.37,16.74,10.95,45.4,23.19,31.78-37.47,31.78-37.47A51.37,51.37,0,0,1,563,441.49c2.15,8.59,12.78,20.4,12.78,20.4,10.31-1.72,19.1-29.95,16.85-31.56S584,408.11,584,408.11c-10.09-14.06-1-43.27-1-43.27s9.23-23.51,9.12-27.37,2.15-4,2.15-4l6.55-44.87s-9-3.76-9.77-6.88-13.64-6.54-13.64-6.54.87-1.29-4.61-3.12a20.19,20.19,0,0,1-5.3-3.24,124.33,124.33,0,0,1-11.85-11s-.55,12.78,2.12,20.17,4.62,29.22,4.83,30.83-7.73,18.46-7.73,18.46l-4.21-5.77c-6.64-9.08-18.87-25.76-19.72-26.54-1.19-1.07-11.48-29.78-12.91-33.36-.53-1.31-1.27-1.73-2-1.74a3,3,0,0,0-1.61.52h0a5.5,5.5,0,0,0-.71.52l-.25.69-.06.14a15.28,15.28,0,0,1-.76,1.72,0,0,0,0,0,0,0h0C505.74,277,480,286.69,480,286.69c-8.26,2.9-9.66,8.77-9.66,8.77s1.5,5.19-1.82,7.77-1.93,9.66-1.93,9.66-4.51,10.2-3.35,11.7a27.57,27.57,0,0,1,2.38,4.08S461.87,331.67,463.8,336Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M547.21,341.87s43.91,6.87,41.87-12c-1.86-17.21-18-53.41-20.86-59.71a125,125,0,0,1-11.86-11s-.54,12.78,2.12,20.17,4.62,29.21,4.83,30.82-7.73,18.47-7.73,18.47Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M545.92,340.59s43.91,6.86,41.87-12c-1.86-17.21-18-53.41-20.86-59.71a124.33,124.33,0,0,1-11.85-11s-.55,12.78,2.11,20.17,4.62,29.22,4.84,30.83-7.73,18.46-7.73,18.46Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M546.57,340.59s43.9,6.86,41.86-12c-1.85-17.21-18-53.41-20.86-59.71a124.33,124.33,0,0,1-11.85-11s-.55,12.78,2.12,20.17,4.62,29.22,4.83,30.83-7.73,18.46-7.73,18.46Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M511.39,264.76h0c0,.13.07,2,.16,4.88.17,5.56.44,15,.58,23.89.16,10.3.16,19.78-.34,21.4-1.18,3.76,4.61,13.1,4.61,13.1l28.88,13.84,7.77-12.35-3.61-6.73c-6.64-9.08-18.87-25.76-19.72-26.54-.38-.34-1.7-3.52-3.35-7.8-3.52-9.09-8.59-23.13-9.56-25.56a3.61,3.61,0,0,0-2-1.75,1.77,1.77,0,0,0-1.61.53h0a5.65,5.65,0,0,0-1,1.34l0,.05a10.26,10.26,0,0,0-.74,1.67Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M513.33,263.47h0c0,.12.07,2,.15,4.87.17,5.56.44,15,.58,23.89.17,10.3.17,19.78-.34,21.4-1.18,3.76,4.62,13.1,4.62,13.1l28.87,13.85L555,328.23l-3.61-6.73c-6.64-9.08-18.86-25.76-19.72-26.54-.38-.34-1.69-3.52-3.35-7.8-3.52-9.08-8.59-23.13-9.56-25.56a3.6,3.6,0,0,0-2-1.74,1.72,1.72,0,0,0-1.61.52h0a5.55,5.55,0,0,0-1,1.35l0,0a10.19,10.19,0,0,0-.74,1.68Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M512.68,263.47h0c0,.12.07,2,.16,4.87.17,5.56.43,15,.58,23.89.16,10.3.16,19.78-.35,21.4-1.17,3.76,4.62,13.1,4.62,13.1l28.88,13.85,7.76-12.36s-1.37-2.58-3.6-6.73c-6.64-9.08-18.87-25.76-19.72-26.54-.38-.34-1.7-3.52-3.35-7.8-3.52-9.08-8.59-23.13-9.56-25.56a3.58,3.58,0,0,0-2-1.74,1.74,1.74,0,0,0-1.61.52h0a5.27,5.27,0,0,0-1,1.35l0,0a10.19,10.19,0,0,0-.74,1.68A0,0,0,0,0,512.68,263.47Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.29,
    cy: 309.33,
    rx: 2.42,
    ry: 4.19,
    opacity: 0.1
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.29,
    cy: 308.68,
    rx: 2.42,
    ry: 4.19,
    fill: "#e87100"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.5,
    cy: 354.25,
    rx: 2.42,
    ry: 4.19,
    opacity: 0.1
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.09,
    cy: 330.47,
    rx: 2.42,
    ry: 4.19,
    opacity: 0.1
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 429.92,
    cy: 374.22,
    rx: 2.42,
    ry: 4.19,
    opacity: 0.1
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.5,
    cy: 353.61,
    rx: 2.42,
    ry: 4.19,
    fill: "#e87100"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.09,
    cy: 329.83,
    rx: 2.42,
    ry: 4.19,
    fill: "#e87100"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 429.92,
    cy: 373.58,
    rx: 2.42,
    ry: 4.19,
    fill: "#e87100"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M507.05,293.94c.63-.48,3.55-1.14,6.37-1.7s5.7-1,5.7-1a17.13,17.13,0,0,1,8.54-4c-3.52-9.08-8.59-23.13-9.56-25.56a3.58,3.58,0,0,0-2-1.74,1.74,1.74,0,0,0-1.61.52h0a5.27,5.27,0,0,0-1,1.35l0,0-.59,6.57-.16,1.76s-4.67,2.25-3.7,6S505.76,294.91,507.05,293.94Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M555.76,262.25s15.88,22.83,15.71,27.34-2.57,0-2.57,0-6.71-19.93-14.54-4.83Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M555.76,261.6s15.88,22.84,15.71,27.35-2.57,0-2.57,0-6.71-19.93-14.54-4.84Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M598.53,291l2.36-2.32S607.06,291,608,294s3.54,2.22,3.54,2.22a14.07,14.07,0,0,0,3.54,1.28c1,0,2.42,4.51,2.42,4.51s10.14,2.58,11,2.74,40.57,37.07,40.57,37.07-22.86,3.51-26.4,2.06-7.09-1.7-8.86-2.06-41.7-8.89-41.7-8.89Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M603.52,271l4.18,5.32,18.52-10.52-3.69-4.34C619.23,266.47,613.35,271.86,603.52,271Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M663.1,339.83l5.95,2s14.5-1.32,13.53-7.6-7.25-17.78-7.25-17.78l-9-15.39s-3.55-4.22-3.22-5.57-4.19-3.61-4.19-3.61-2.58-3.38-2.74-5S641.52,273,641.52,273s-5-4.19-3.87-18.36H626.22s-5.25,21.1-25.33,17.23l27.59,32.85Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M436.9,511a35.65,35.65,0,0,0,18.08,5c1.26-6.29,1.85-11,1.85-11H439.27S438.23,507.41,436.9,511Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M468.9,340.59l-5.1,4.29s1,2.36-.74,3.65,0,11.11,0,11.11a5.84,5.84,0,0,1-1.4,3.59c-1.45,1.72,0,18.47,0,18.47a5.58,5.58,0,0,1-1.77,2.09c-1,.48-3.87,16.27-3.06,17.07s-12.24,38.81-12.24,38.81.32,6.6-1.45,7.73-2.09,8.69-2.09,8.69.8,6.76-2.42,8.05-3.86,24.16-3.86,24.16-4.35,11.75-6.93,13.68c0,0,12.24,16.75,35.91,11.92,0,0,1-21.1,3.86-29.47l8.54-42.67s5.15-18.2,7.08-28.18,10.42-48.31,10.42-48.31V351.59Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#65617d"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.54,
    cy: 419.79,
    rx: 1.13,
    ry: 2.25,
    opacity: 0.1
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.03,
    cy: 438.95,
    rx: 1.13,
    ry: 2.25,
    opacity: 0.1
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.65,
    cy: 456.5,
    rx: 1.13,
    ry: 2.25,
    opacity: 0.1
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.28,
    cy: 429.45,
    rx: 1.13,
    ry: 2.25,
    opacity: 0.1
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.77,
    cy: 448.13,
    rx: 1.13,
    ry: 2.25,
    opacity: 0.1
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.54,
    cy: 419.15,
    rx: 1.13,
    ry: 2.25,
    fill: "#e87100"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.03,
    cy: 438.31,
    rx: 1.13,
    ry: 2.25,
    fill: "#e87100"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.65,
    cy: 455.86,
    rx: 1.13,
    ry: 2.25,
    fill: "#e87100"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.28,
    cy: 428.81,
    rx: 1.13,
    ry: 2.25,
    fill: "#e87100"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.77,
    cy: 447.49,
    rx: 1.13,
    ry: 2.25,
    fill: "#e87100"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M525.44,371.61s-17.4-3-22.72,0S525.44,371.61,525.44,371.61Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M513.74,388.62s-9-14.65-11.69-10S513.74,388.62,513.74,388.62Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M471.64,404.89c-.48.48-19.65,22.38-19.48,23.83S471.64,404.89,471.64,404.89Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M643.61,327.27c-.16.49-5.16,10.47-1.85,11.6S643.61,327.27,643.61,327.27Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M628.64,313.42s-7.57,2.74-8.86,4S628.64,313.42,628.64,313.42Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M654.24,306c-3.54-.16-16.1-3.55-16.59-2.42S654.24,306,654.24,306Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M522.38,244.62c-.53,12.52-7.7,23.51-7.7,23.51l12,29.19v8.49c8.16.86,16.76-.91,22.7-6.46-4.71-1.54-7.58-6.22-9.77-10.67a123.53,123.53,0,0,1-6.53-16.16c-1.2-3.71-1.82-8.65,1.48-10.74,1.51-1,3.51-1,4.91-2.12,1.81-1.45,1.93-4.2,1.31-6.43-.07-.24-.14-.48-.22-.71-1.46-4.34-4.9-7.77-7-11.87a21.46,21.46,0,0,1-1.27-15.91,19.86,19.86,0,0,1,2.31-5,21.43,21.43,0,0,1,18.57-9.64c1.87.08,4.16.2,5.11-1.4.74-1.22.21-2.8.45-4.21.71-4.3,6-5.25,11-6.59a32.24,32.24,0,0,0-26.37-14c-18.08,0-32.75,15.38-32.75,34.36A35,35,0,0,0,522.38,244.62Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M557.48,204.5c-.24,1.41.29,3-.44,4.22-1,1.59-3.25,1.47-5.11,1.39a21,21,0,0,0-19.62,30.54c2.2,4.32,5.9,7.9,7.21,12.57.62,2.24.5,5-1.31,6.44-1.39,1.13-3.4,1.16-4.91,2.12-3.3,2.09-2.68,7-1.48,10.74a122.2,122.2,0,0,0,6.54,16.16c2.18,4.45,5,9.13,9.76,10.67-6.88,6.42-17.3,7.8-26.5,5.85s-17.51-6.74-25.64-11.48c-3.34-1.94-6.87-4.09-8.5-7.59-2.22-4.76-.24-10.29,1.17-15.34a6.14,6.14,0,0,0,.17-3.94c-.63-1.52-2.27-2.31-3.79-3-6.42-2.68,6-5,0-8.56s-11.46-8.44-14.2-14.84c-4.67-10.89-.46-23.88,7-33.09s-1.28-15.63,8.26-22.66c6.08-4.49,12-9.33,18.76-12.69a51.5,51.5,0,0,1,44.11-.29c6.93,3.25,12.58,8.49,19.38,12,3.35,1.73,10.7,3.92,8.83,8.72C574.34,199.76,558.74,196.91,557.48,204.5Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#3f3d56"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M490.23,469.84s24,21.9,18.89,21.9S490.23,469.84,490.23,469.84Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M486.79,478.43s15.89,15,11.17,16.31S486.79,478.43,486.79,478.43Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M480.22,442.18s1.32.86,3.86,2.38c4.31-4.32,10.63-11.27,12.68-16.87,3.22-8.81,1.93-34.35,1.93-34.35-1.08,1.07-2.69,10-2.69,10l-3.83,14.26-.67.56c-6,4.93-6.77,13.52-8.49,15.67S480.22,442.18,480.22,442.18Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.62,
    cy: 743.69,
    r: 8.7,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.95,
    cy: 702.77,
    r: 8.7,
    fill: "#3f3d56"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M180.79,714.26c10.5-.53,36.26-1.17,41.42-3.75s61.19-62.16,61.19-62.16l16.74-24.47,27.38-11.59,22.86-26.11,18.05-11.54s-3.88,1.22-4.2-2.63a9.17,9.17,0,0,0-.72-2.88,7.16,7.16,0,0,0-2.09-2.88,4.46,4.46,0,0,0-4.6-.66c-4.18,1.61-59.16,10.95-59.16,10.95s-17.16,2.9-32.94,23.83a267.71,267.71,0,0,1-30,33.81l-42.84,51.21S170.29,714.79,180.79,714.26Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.66,726.93l42.51,54.35,1.52-.71L305.29,743l32.85-33.17s71.18-75,76.65-86.31-15.72-29.95-15.72-29.95c-16.68-29.31-25.82-20.29-25.82-20.29l-80.78,22.21h-.06L292,596c-6.27,6.67-77.29,82.26-100.44,105.93l-.05.06h0c-3.29,3.37-5.61,5.68-6.61,6.57C176.48,716,180.66,726.93,180.66,726.93Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#e87100"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M180.66,726.93l42.51,54.35,1.52-.71c22.49-28.23,77.94-97.29,93.49-111.37C337.82,651.4,333,640.3,333,640.3l-16.75-22.86c-12.63-23.42-22.9-22.08-23.77-21.91h-.06L292,596,191.53,701.94l-.05.06h0c-3.29,3.37-5.61,5.68-6.61,6.57C176.48,716,180.66,726.93,180.66,726.93Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M375.18,592.64l-7.09-6.12S352,583,338.47,598.76l4.83,5.8S355.53,590.39,375.18,592.64Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#3f3d56"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M375.18,592.64l-7.09-6.12S352,583,338.47,598.76l4.83,5.8S355.53,590.39,375.18,592.64Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.85 590.48 326.76 500.98 322.58 499.34 252.37 587.26 257.85 590.48",
    fill: "#65617d"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.02 597.88 303.52 508.68 300.04 504.17 227.57 594.02 234.02 597.88",
    fill: "#65617d"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M431.86,548.63c-.75-.24-7.52-6.12-7.52-6.12h0a49.82,49.82,0,0,1,20.82-17.92c7.47-3.42,15.83-6.09,19.23-3,0,0,5.9,7.23-1.08,12.85l-5-1.26s-7.52-8.37-19.76,7.51Z",
    transform: "translate(-129.25 -37.59)",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.06 496.84 324.94 506.21 318.07 503.09 326.07 492.9 330.31 494.18 334.06 496.84",
    fill: "#3f3d56"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M251.84,628.06c.53-.54,31.42-31.61,40.36-38,7.82-5.58,58.1-17.79,71.31-20.93a7.16,7.16,0,0,0-2.09-2.88c-12.6,3.4-53.19,14.34-66,17.59C280.29,587.67,252.28,627.43,251.84,628.06Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "236.92 537.67 163.37 557.13 51.54 676.67 51.54 673.24 161.23 556.49 236.92 537.67",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M517.41,304.17c9.21,1.95,19.63.57,26.51-5.85-4.71-1.55-7.58-6.22-9.77-10.67a122.15,122.15,0,0,1-6.53-16.16c-1.21-3.71-1.83-8.65,1.47-10.74,1.52-1,3.52-1,4.92-2.12,1.81-1.45,1.93-4.2,1.3-6.44-1.3-4.67-5-8.25-7.21-12.57a21,21,0,0,1,19.62-30.54c1.86.08,4.16.2,5.11-1.39.73-1.23.21-2.81.44-4.22,1.27-7.59,16.86-4.74,19.68-12,1.86-4.8-5.48-7-8.83-8.72-6.8-3.52-12.45-8.76-19.38-12-1.14-.53-2.31-1-3.49-1.47A50.38,50.38,0,0,1,548.6,172c6.93,3.25,12.58,8.49,19.38,12,3.35,1.74,10.7,3.93,8.83,8.73-2.81,7.26-18.41,4.41-19.67,12-.24,1.41.29,3-.44,4.22-1,1.59-3.25,1.47-5.11,1.39A21,21,0,0,0,532,240.9c2.2,4.33,5.9,7.91,7.21,12.58.62,2.24.5,5-1.31,6.44-1.39,1.13-3.39,1.16-4.91,2.12-3.3,2.09-2.68,7-1.48,10.74A122.2,122.2,0,0,0,538,288.94c2.18,4.45,5.05,9.12,9.76,10.67-6.88,6.42-17.3,7.79-26.5,5.85a50.26,50.26,0,0,1-7.25-2.13C515.15,303.65,516.27,303.93,517.41,304.17Z",
    transform: "translate(-129.25 -37.59)",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.c2fc587c.svg";
export { ForwardRef as ReactComponent };